/**
 * Calculates displacement vector of 2 points, returns an object { x, y }
 */
export default function getDisplacement(a, b, scale = 1) {
  return {
    x: (b.x - a.x) / scale,
    y: (b.y - a.y) / scale
  }
}
